import { createAction } from '@reduxjs/toolkit';
import { Extension } from '../../api';

export const loadExtensionsRequested = createAction<
  { saveLastState: boolean },
  'al/extension/loadExtensionsRequested'
>('al/extension/loadExtensionsRequested');

export const extensionsChanged = createAction<
  { extensions: Extension[] },
  'al/extension/extensionsChanged'
>('al/extension/extensionsChanged');

export const extensionsSelected = createAction<
  { ids: Extension['id'][]; saveLastState: boolean },
  'al/extension/extensionsSelected'
>('al/extension/extensionsSelected');

export const setExpandedKeys = createAction<
  { keys: Extension['id'][]; saveLastState: boolean },
  'al/extension/setExpandedKeys'
>('al/extension/setExpandedKeys');

export const setLoading = createAction<{ loading: boolean }, 'al/extension/setLoading'>(
  'al/extension/setLoading',
);
